<template>
    <!-- Site Details - Start -->
    <div class="row">
        <div class="col-12">
            <div class="">
                <span class="mr-3 align-middle col-mb heading-text">
                    Site Details
                </span>
                <span class="badge bg-violate" v-if="envType === 'staging'">Staging</span>
                <span class="badge bg-success" v-else>Live</span>

            </div>
        </div>
        <div class="col-sm-12 col-md-3">
            <span class="col-mb d-block">
                Site Locked:
                <span data-toggle="tooltip" data-placement="top" style="cursor: pointer" title="This option restricts your websites visibility to everyone except those who have the password defined in the Site Lock Username / Passwords fields to the right." class="m_tip"><i class="fa fa-question-circle text-primary"></i></span>
            </span>
            <select class="form-control-sm" v-model="siteLockedData.status" @change="askSiteLockWarning()">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
        </div>
        <div class="col-sm-12 col-md-3">
            <span class="col-mb d-block">Site Lock Username:</span>
            <span v-if="siteLockDisable">
                {{siteLockedData.username}}
                <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(siteLockedData.username)" style="margin: 0"></i>
            </span>
            <div v-else>
                <input type="text" class="form-control form-control-sm" v-model="siteLockedData.username" />
            </div>
        </div>
        <div class="col-sm-12 col-md-3">
            <span class="col-mb d-block" >Site Lock Password:</span>
            <span v-if="siteLockDisable">
                {{siteLockedData.password}}
                <i class="fa fa-copy btn btn-link text-primary" @click="doCopy(siteLockedData.password)" style="margin: 0"></i>
            </span>
            <div class="input-group input-group-sm" v-else>
                <input type="text" class="form-control" v-model="siteLockedData.password">
                <div class="input-group-append">
                    <button @click="generatePassword()" class="btn btn-primary btn-sm" style="margin: 0"><i class="fa fa-pencil"></i></button>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-3">
            <div style="margin-top: 10px" v-if="siteLockDisable">
                <button @click="siteLockDisable = !siteLockDisable" type="button" class="btn btn-outline-primary btn-round btn-sm"><i class="fa fa-pencil"></i></button>
            </div>
            <div style="margin-top: 10px" v-else>
                <button @click="saveSiteLockSettings()" type="button" class="btn btn-outline-primary btn-round btn-sm"><i class="fa fa-floppy-o"></i></button>
                <button @click="siteLockDisable = !siteLockDisable" style="margin-left: 10px" type="button" class="btn btn-outline-danger btn-round btn-sm"><i class="fa fa-ban"></i></button>
            </div>
        </div>
<!--        <div class="col-sm-12 col-md-3" v-if="envType === 'live'">-->
<!--            <br/>-->
<!--            <span class="col-mb d-block">-->
<!--                Developer Mode:-->
<!--                <span data-toggle="tooltip" data-placement="top" style="cursor: pointer" title="Putting your site into developer mode stops the CDN from caching your static content like images, css, javascript.  This will automatically turn off after 3 hours." class="m_tip"><i class="fa fa-question-circle text-primary"></i></span>-->
<!--            </span>-->
<!--            <select class="form-control-sm" v-model="siteCFDeveloperMode" @change="changeDeveloperMode()">-->
<!--                <option value="on">On</option>-->
<!--                <option value="off">Off</option>-->
<!--            </select>-->
<!--        </div>-->
<!--        <div class="col-sm-12 col-md-3" v-if="envType === 'live'">-->
<!--            <br/>-->
<!--            <span class="col-mb d-block">-->
<!--                Cloud Flare Status:-->
<!--                <span data-toggle="tooltip" data-placement="top" style="cursor: pointer" title="Controls whether or not your traffic will bypass Cloudflare.  We highly recommend never disabling this and instead using Developer mode." class="m_tip"><i class="fa fa-question-circle text-primary"></i></span>-->
<!--            </span>-->
<!--            <select class="form-control-sm" v-model="siteCF" @change="changeSiteCF()">-->
<!--                <option value="enabled">Enabled</option>-->
<!--                <option value="disabled">Disabled</option>-->
<!--            </select>-->
<!--        </div>-->
        <div class="col-12">
            <hr/>
        </div>
    </div>
    <!-- Site Details - End -->
</template>

<script>
    import swal from 'sweetalert2'
    import {db} from "@/firebase/init";
    import copyButtonMixin from '../../../../mixins/copyButtonMixin';
    import _ from 'lodash'
    import adminLogs from "../../../../mixins/adminLogs";
    export default {
        name: "SiteLock",
        data() {
            return {
                siteLockDisable: true,
                siteLockedData: {
                    username: '',
                    password: '',
                    status: 'No'
                },
                // siteCFDeveloperMode: 'off',
                // siteCF: 'enabled',
                currentAccount: ""
            }
        },
        computed: {
            userToken() {
                return this.$store.getters.getUserToken;
            },
            UID() {
                return this.$store.getters.requestUserId;
            }
        },
        mixins: [copyButtonMixin, adminLogs],
        props: {
            account: {
                type: Object,
                required: true
            },
            envType: {
                type: String,
                required: true
            },
            collaboration: {
                type: Boolean,
                required: false
            },
            supervisor: {
                type: Object,
                required: false,
                default() {return {};}
            }
        },
        watch: {
          account(newSelectedAccount) {
              this.initData(newSelectedAccount);
          }
        },
        mounted() {
            /* eslint-disable */
            $(function () {
                $('[data-toggle="tooltip"]').tooltip();
            });
            /* eslint-enable */
            this.initData(this.account);
        },
        methods: {
            initData(account){
                this.currentAccount = _.cloneDeep(account);
                if(this.currentAccount.siteLock){
                    this.siteLockedData = _.cloneDeep(this.currentAccount.siteLock);
                }else{
                    console.log('No data exist...');
                    this.siteLockedData = {
                        username: (this.envType === 'staging') ? 'dev' : '',
                        password: (this.envType === 'staging') ? 'dev' : '',
                        status: (this.envType === 'staging') ? 'Yes' : 'No'
                    }
                }
                // this.fetchSiteCFData(account);
                // console.log(this.currentAccount);
                // console.log(this.siteLockedData);
            },
            askSiteLockWarning () {
                if (this.envType === 'live') {
                    swal({
                        title: "Site Lock",
                        text: 'Are you sure to change this setting?',
                        type: "question",
                        confirmButtonText: "Yes Please!",
                        confirmButtonColor: "#6ACF98",
                        showCancelButton: true,
                        cancelButtonText: "No!",
                        cancelButtonColor: "#EE8057"
                    }).then(result => {
                        if(result.value) {
                            this.saveSiteLockSettings();
                        } else {
                            this.siteLockedData.status = (this.siteLockedData.status === 'Yes') ? 'No' : 'Yes';
                        }
                    });
                } else {
                    this.saveSiteLockSettings();
                }
            },
            async saveSiteLockSettings() {
                const domain = this.currentAccount.domain;
                const ip = this.currentAccount.ftp.host;
                if(ip === null || domain === null) {
                    swal('Error!', 'Invalid IP or Domain', 'error');
                    return;
                }
                const accountDetails = this.$store.getters['hosting/accounts'];
                let hostingAccountIndex = 0;
                let adOnAccountIndex = 0;
                let isAdOnAccount = false;
                let isAbortSearching = false;
                for(const account of accountDetails){
                    adOnAccountIndex = 0;
                    if(account.primary.domain === domain){
                        break;
                    }
                    if(account.primary.staging.domain === domain){
                        break;
                    }
                    for(const adon of account.addon){
                        if(adon.domain === domain){
                            isAdOnAccount = true;
                            isAbortSearching = true;
                            break;
                        }
                        if(adon.staging.domain === domain){
                            isAdOnAccount = true;
                            isAbortSearching = true;
                            break;
                        }
                        adOnAccountIndex++;
                    }
                    if(isAbortSearching){
                        break;
                    }
                    hostingAccountIndex++;
                }
                // console.log(domain);
                // console.log({'IsAd-onAccount': isAdOnAccount, 'HostingAccountIndex': hostingAccountIndex, 'AdOnAccountIndex': adOnAccountIndex});
                this.$store.dispatch("async/stateUpdate", { state: false, text: 'Modifying Site Lock Settings...' });
                if(this.siteLockedData.status === 'No'){
                    try{
                        const siteLockResponse = await this.$http.post('site-lock/off', {
                            grant_type: "token",
                            token: this.userToken,
                            ip: ip,
                            domain: domain
                        });
                        console.log(siteLockResponse);
                        this.updateDB(isAdOnAccount, hostingAccountIndex, adOnAccountIndex, domain);
                    }catch (e) {
                        swal({
                            title: "Something went wrong!",
                            html: e.response.data.message,
                            type: "error",
                            confirmButtonText: "Try Again!",
                            confirmButtonColor: "#EE8057"
                        });
                        this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
                    }
                }else if(this.siteLockedData.status === 'Yes' &&
                    this.siteLockedData.username !== '' &&
                    this.siteLockedData.password !== ''){
                    try{
                        const siteLockResponse = await this.$http.post('site-lock/on', {
                            grant_type: "token",
                            token: this.userToken,
                            ip: ip,
                            domain: domain,
                            username: this.siteLockedData.username,
                            password: '\''+this.siteLockedData.password+'\''
                        });
                        console.log(siteLockResponse);
                        this.updateDB(isAdOnAccount, hostingAccountIndex, adOnAccountIndex, domain);
                    }catch (e) {
                        swal({
                            title: "Something went wrong!",
                            html: e.response.data.message,
                            type: "error",
                            confirmButtonText: "Try Again!",
                            confirmButtonColor: "#EE8057"
                        });
                        this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
                    }
                }else{
                    swal({
                        title: "Invalid Input",
                        html: 'Enter valid username and password',
                        type: "error",
                        confirmButtonText: "Try Again!",
                        confirmButtonColor: "#EE8057"
                    });
                    this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
                }
            },
            updateDB(isAdOnAccount, hostingAccountIndex, adOnAccountIndex, domain) {
                db.collection("hostingAccounts").doc(this.UID).get().then(doc => {
                    let existingHostingData = doc.data().accounts;
                    if(isAdOnAccount){
                        if(this.envType === 'staging'){
                            existingHostingData[hostingAccountIndex].addon[adOnAccountIndex].staging.siteLock = this.siteLockedData;
                        }else{
                            console.log(existingHostingData);
                            console.log(hostingAccountIndex);
                            console.log(adOnAccountIndex);
                            existingHostingData[hostingAccountIndex].addon[adOnAccountIndex].siteLock = this.siteLockedData;
                        }
                    }else{
                        if(this.envType === 'staging'){
                            existingHostingData[hostingAccountIndex].primary.staging.siteLock = this.siteLockedData;
                        }else{
                            existingHostingData[hostingAccountIndex].primary.siteLock = this.siteLockedData;
                        }
                    }
                    // console.log(existingHostingData);
                    db.collection("hostingAccounts").doc(this.UID).set({accounts: existingHostingData}).then(()=>{
                        this.$store.dispatch("hosting/fetchAccounts", {UID: this.UID, allowedDomains: this.supervisor.allowedDomains}).then(() => {
                            this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
                            swal({
                                type: "success",
                                title: 'Request Completed!',
                                text: "Lock settings has been successfully updated.",
                            });
                            this.siteLockDisable = true;
                        })
                      this.addLog({
                        name: this.user.firstName + " " + this.user.lastName,
                        message: "Lock settings has been successfully updated",
                        level: "info"
                      });

                    }).catch((e) => {
                        console.log(e);
                        swal({
                            type: "error",
                            title: 'Request Failed!',
                            text: "Error in saving data. Please contact support!",
                        });
                        this.addLog({
                            name: this.user.firstName + " " + this.user.lastName,
                            message: "In modifying lock settings of domain: "+domain+" => Error in saving data in firebase",
                            level: "danger"
                        });
                    });
                });
            },
            generatePassword() {
                const characters = 'a-z,A-Z,0-9,#';
                const size = 12;
                let charactersArray = characters.split(',');
                let CharacterSet = '';
                let password = '';

                if( charactersArray.indexOf('a-z') >= 0) {
                    CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
                }
                if( charactersArray.indexOf('A-Z') >= 0) {
                    CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
                }
                if( charactersArray.indexOf('0-9') >= 0) {
                    CharacterSet += '0123456789';
                }
                if( charactersArray.indexOf('#') >= 0) {
                    CharacterSet += '![]{}()%&*$#^<>~@|';
                }

                for(let i=0; i < size; i++) {
                    password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
                }
                this.siteLockedData.password = password;
            },
            // async fetchSiteCFData(account) {
            //     if(this.envType === 'live' && (account.cloudflare.apiKey !== null && account.cloudflare.apiKey !== '')
            //         && (account.cloudflare.username !== null && account.cloudflare.username !== '')
            //         && (account.cloudflare.zone_id !== null && account.cloudflare.zone_id !== '') ){
            //         const zoneDetails = await this.$http.get('provider/zone_details?api_key=' + account.cloudflare.apiKey + '' +
            //             '&user_email=' + account.cloudflare.username + '' +
            //             '&zone_id=' + account.cloudflare.zone_id);
            //         const zoneDetailsData = zoneDetails.data;
            //         console.log(zoneDetailsData);
            //         if(zoneDetailsData.data.developerMode.success){
            //             this.siteCFDeveloperMode = zoneDetailsData.data.developerMode.result.value;
            //         }
            //         if(zoneDetailsData.data.siteCF.success){
            //             this.siteCF = (!zoneDetailsData.data.siteCF.result.paused) ? 'enabled' : 'disabled';
            //         }
            //         console.log(this.siteCFDeveloperMode, this.siteCF);
            //     }
            // },
            // async changeDeveloperMode() {
            //     this.$store.dispatch("async/stateUpdate", { state: false, text: 'Modifying Developer Mode Settings...' });
            //     console.log(this.currentAccount.cloudflare);
            //     const account = this.currentAccount;
            //     try{
            //         if(this.envType === 'live' && (account.cloudflare.apiKey !== null && account.cloudflare.apiKey !== '')
            //             && (account.cloudflare.username !== null && account.cloudflare.username !== '')
            //             && (account.cloudflare.zone_id !== null && account.cloudflare.zone_id !== '') ){
            //             const zoneDetails = await this.$http.post('provider/development_mode', {
            //                 user_email: account.cloudflare.username,
            //                 api_key: account.cloudflare.apiKey,
            //                 zone_id: account.cloudflare.zone_id,
            //                 mode: this.siteCFDeveloperMode
            //             });
            //             const zoneDetailsData = zoneDetails.data;
            //             this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
            //             console.log(zoneDetailsData);
            //             if(zoneDetailsData.data.success){
            //                 this.siteCFDeveloperMode = zoneDetailsData.data.result.value;
            //                 swal({
            //                     type: "success",
            //                     title: 'Request Completed!',
            //                     text: "Developer mode settings has been updated.",
            //                 });
            //             }
            //         }
            //     }catch (e) {
            //         swal({
            //             title: "Something went wrong!",
            //             html: 'Please try again!',
            //             type: "error",
            //             confirmButtonText: "Try Again!",
            //             confirmButtonColor: "#EE8057"
            //         });
            //         this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
            //     }
            //
            // },
            // async changeSiteCF() {
            //     this.$store.dispatch("async/stateUpdate", { state: false, text: 'Modifying Cloud Flare Zone Settings...' });
            //     console.log(this.currentAccount.cloudflare);
            //     const account = this.currentAccount;
            //     try{
            //         if(this.envType === 'live' && (account.cloudflare.apiKey !== null && account.cloudflare.apiKey !== '')
            //             && (account.cloudflare.username !== null && account.cloudflare.username !== '')
            //             && (account.cloudflare.zone_id !== null && account.cloudflare.zone_id !== '') ){
            //             const zoneDetails = await this.$http.post('provider/zone_details', {
            //                 user_email: account.cloudflare.username,
            //                 api_key: account.cloudflare.apiKey,
            //                 zone_id: account.cloudflare.zone_id,
            //                 mode: (this.siteCF === 'enabled') ? 'false' : 'true'
            //             });
            //             const zoneDetailsData = zoneDetails.data;
            //             this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
            //             console.log(zoneDetailsData);
            //             if(zoneDetailsData.data.success){
            //                 this.siteCF = (!zoneDetailsData.data.result.paused) ? 'enabled' : 'disabled';
            //                 swal({
            //                     type: "success",
            //                     title: 'Request Completed!',
            //                     text: "Cloud Flare zone settings has been updated.",
            //                 });
            //             }
            //         }
            //     }catch (e) {
            //         swal({
            //             title: "Something went wrong!",
            //             html: 'Please try again!',
            //             type: "error",
            //             confirmButtonText: "Try Again!",
            //             confirmButtonColor: "#EE8057"
            //         });
            //         this.$store.dispatch("async/stateUpdate", { state: true, text: '' });
            //     }
            // }
        }
    }
</script>

